import { ApolloClient } from "@apollo/client";
import { GestionarProductoDetalleDtSource } from "../../business/dataSources/GestionarProductoDetalleDtSource";
import { Recurso } from "lib.common/dist/CleanArch";
import { ProductoDetalleDsKey } from "../../business/entities/ProductoTiendaDsKey";
import { DeleteProductoDetalleParams, UpdateProductoDetalleParams } from "../../utils/params/ProductoDetalleParams";
import { actualizarProductoDetalleGql, agregarProductoDetalleGql, eliminarProductoDetalleGql, getProductoDetalleGql } from "../../utils/queries/gestionarProductoDetalle";
import { gqlErrorsMapperRecurso } from "lib.front/dist/common/funErrorMappers";
import { ErrExterno } from "lib.common/dist/errorHandler";

export class GestionarProductoDetalleDtSourceImplGql implements GestionarProductoDetalleDtSource {
    private apolloClient: ApolloClient<object>;

    constructor(ApolloClient: ApolloClient<object>) {
        this.apolloClient = ApolloClient;
    }

    async getAllProductoDetalle(): Promise<Recurso<ProductoDetalleDsKey[]>> {
        try {
            const response = await this.apolloClient.query({
                query: getProductoDetalleGql,
            });
            const errorRecurso = gqlErrorsMapperRecurso<ProductoDetalleDsKey[]>(response.errors);
            return errorRecurso ?? Recurso.fromData(response.data.productoDetalles);
        } catch (error) {
            return Recurso.fromError<ProductoDetalleDsKey[]>(new ErrExterno(error as Error));
        }
    }

    async addProductoDetalle(input: UpdateProductoDetalleParams): Promise<Recurso<ProductoDetalleDsKey>> {
        try {
            const variables = {
                codigoProducto: input.codigoProducto,
                codigoVersion: input.codigoVersion,
                codigoPresentacion: input.codigoPresentacion,
                urlInstalador: input.urlInstalador
            }
            const response = await this.apolloClient.mutate({
                mutation: agregarProductoDetalleGql,
                variables
            });
            const errorRecurso = gqlErrorsMapperRecurso<ProductoDetalleDsKey>(response.errors);
            return errorRecurso ?? Recurso.fromData(response.data.agregarProductoDetalle);
        } catch (error) {
            return Recurso.fromError<ProductoDetalleDsKey>(new ErrExterno(error as Error));
        }
    }

    async updateProductoDetalle(input: UpdateProductoDetalleParams): Promise<Recurso<ProductoDetalleDsKey>> {
        try {
            const variables = {
                codigoProducto: input.codigoProducto,
                codigoVersion: input.codigoVersion,
                codigoPresentacion: input.codigoPresentacion,
                urlInstalador: input.urlInstalador
            }
            const response = await this.apolloClient.mutate({
                mutation: actualizarProductoDetalleGql,
                variables
            });
            const errorRecurso = gqlErrorsMapperRecurso<ProductoDetalleDsKey>(response.errors);
            return errorRecurso ?? Recurso.fromData(response.data.actualizarProductoDetalle);
        } catch (error) {
            return Recurso.fromError<ProductoDetalleDsKey>(new ErrExterno(error as Error));
        }
    }

    async deleteProductoDetalle(input: DeleteProductoDetalleParams): Promise<Recurso<ProductoDetalleDsKey>> {
        try {
            const variables = {
                codigoProducto: input.codigoProducto,
                codigoVersion: input.codigoVersion,
                codigoPresentacion: input.codigoPresentacion
            }
            const response = await this.apolloClient.mutate({
                mutation: eliminarProductoDetalleGql,
                variables
            });
            const errorRecurso = gqlErrorsMapperRecurso<ProductoDetalleDsKey>(response.errors);
            return errorRecurso ?? Recurso.fromData(response.data.eliminarProductoDetalle);
        } catch (error) {
            return Recurso.fromError<ProductoDetalleDsKey>(new ErrExterno(error as Error));
        }
    }

}